export interface IAddUserRequest {
  contractCode: string,
  description: string | null,
  email: string,
  name: string | null,
  surname: string | null,
  terminalId: string | null
}

export class AddUserRequest implements IAddUserRequest {
  public contractCode: string;
  public description: string | null;
  public email: string;
  public name: string | null;
  public surname: string | null;
  public terminalId: string | null;
  public softposTerminalId: string | null;

  constructor(contractCode: string, description: string | null, email: string, name: string | null, surname: string | null, terminalId: string | null, softposTerminalId: string | null) {
    this.contractCode = contractCode;
    this.description = description;
    this.email = email;
    this.name = name;
    this.surname = surname;
    this.terminalId = terminalId;
    this.softposTerminalId = softposTerminalId;
  }
}